<template lang="html">
  <div class="footer">
      © 2017 <a href="https://github.com/flym_" target="_blank">flym_</a> 强力驱动
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.footer{
position: fixed;
bottom: 0;
width: 100%;
height: 50px;
background-color: #f8f8f8;
text-align: center;
font-size: 16px;
color: #666;
border-top: 1px solid #ddd;
a{
  color: #666;
}
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue